import { Vue, Component, Prop } from 'vue-property-decorator';
import IPSDialog from '../picker/dialog';
import DialogFactory from '../picker/dialogFactory';
import ExportFile from '../exportFile';
import { COUPONS_TYPE, COUPONS_TYPE_LIST, typeList } from './couponsList';
import style from '@/views/components/linkForm/style.vue';
import { IPSService } from '@/services/ipsServices';
import { noop } from '@/util';
import { Functions } from '@/library/utils/functions';

const apiService = {
  coupon: 'siteCouponProductList',
  tag: 'tagProductList',
};

@DialogFactory
@Component({
  mixins: [style],
})
export default class RealtionProductList extends IPSDialog {
  title = '关联商品';

  service = 'coupon';

  keywords = '';

  gsciId;
  tagId;

  dataList = [];

  page = 1;

  pageSize = 10;

  totalCount = 0;

  footer = false;

  siteId = 0;

  loadingState = false;

  mounted() {
    if (this.gsciId || this.tagId) {
      this.getData();
    }
  }

  getData() {
    this.loadingState = true;
    IPSService[apiService[this.service]]({
      postParams: {
        siteId: this.siteId,
        gsciId: this.gsciId,
        tagId: this.tagId,
        keyword: this.keywords,
        page: this.page,
        pageSize: this.pageSize,
      },
    }).then(
      (response) => {
        this.totalCount = response.count;
        this.dataList
          = response.list
          || [].map((item) => {
            item.productCode = Functions.emptyVaribleHandler(item.productCode);
            item.productName = Functions.emptyVaribleHandler(item.productName);
            item.originPrice = Functions.emptyVaribleHandler(item.originPrice);
            item.openState = Functions.emptyVaribleHandler(item.openState);
          });
        this.loadingState = false;
      },
      () => {
        this.loadingState = false;
      },
    );
  }

  onSearch() {
    this.page = 1;
    this.getData();
  }

  onPageSizeChange(val) {
    this.page = 1;
    this.pageSize = val;
    this.getData();
  }

  onPageChange(val) {
    this.page = val;
    this.getData();
  }

  /**
   * 刷新相关商品
   */
  onRefresh() {
    this.getData();
  }

  get exportParams() {
    return {
      siteId: this.siteId,
      gsciId: this.gsciId,
      keyword: this.keywords,
    };
  }

  beforeClose() {
    this.$emit('hidden');
  }

  renderContent(h) {
    return (
      <div class="select-list">
        <div class="filterController">
          <div class="inputWrapper wid-185">
            <el-input v-model={this.keywords} placeholder="输入商品货号/商品名称" />
            <i class="iconfont iconsousuo" onClick={this.onSearch.bind(this)} />
          </div>
        </div>
        <el-table tooltip-effect="light" data={this.dataList} height="350px" v-loading={this.loadingState}>
          <el-table-column type="index" label="#" width="110" align="center" show-overflow-tooltip={true} />
          <el-table-column prop="productCode" label="商品货号" align="left" width="160" show-overflow-tooltip={true} />
          <el-table-column prop="productName" label="商品名称" align="left" width="320" show-overflow-tooltip={true} />
          <el-table-column
            prop="originPrice"
            label="商品牌价"
            align="right"
            width="200"
            show-overflow-tooltip={true}
            {...{
              scopedSlots: {
                default: (scoped) => {
                  return <span>￥{scoped.row.originPrice}</span>;
                },
              },
            }}
          />
          <el-table-column
            prop="openState"
            label="商品状态"
            align="left"
            width="200"
            show-overflow-tooltip={true}
            {...{
              scopedSlots: {
                default: (scoped) => {
                  return <span>{['已下架', '销售中', '已售罄'][scoped.row.openState]}</span>;
                },
              },
            }}
          />
        </el-table>
        <div class="bottomWrapper">
          <el-pagination
            on-size-change={this.onPageSizeChange}
            on-current-change={this.onPageChange}
            current-page={this.page}
            page-sizes={[10, 30, 60, 100]}
            page-size={this.pageSize}
            layout="total, sizes, prev, pager, next, jumper"
            total={this.totalCount}
          />
        </div>
        <div class="bottomWrapper" style="border-top: 1px solid #EBEEF5">
          {!this.tagId ? (
            <span>
              <ExportFile export-text="导出" params={this.exportParams} http-type="post" is-button="false" service-url="siteCouponProductExport"></ExportFile>
              <span class="scopeSpan q-link r-ml-14" onClick={this.onRefresh.bind(this)}>
                刷新关联商品
              </span>
            </span>
          ) : (
            <span />
          )}

          <el-button onClick={this.beforeClose}>关闭</el-button>
        </div>
      </div>
    );
  }
}
